<!-- GlobalMessage.vue -->
<template>
  <transition name="slide-up-fade">
    <div v-if="visible" class="global-message" :class="{ max: minDialogFlag }">
      <div class="message-head">
        <span class="message-title"
          >消息提醒（<span>{{ messageCount }}</span
          >）</span
        >
        <i class="close_message_icon" @click="closeMessage"></i>
        <i
          class="min_message_icon"
          v-if="!minDialogFlag"
          @click="minDialogFlag = true"
        ></i>
        <i
          class="max_message_icon"
          v-if="minDialogFlag"
          @click="minDialogFlag = false"
        ></i>
      </div>

      <div class="message-content">
        <div
          class="message-item"
          @click="goMyNotice(item.id, item.type)"
          v-for="(item, index) in currentMessage"
          :key="index"
        >
          <div class="message-item-title" :title="item.topic">
            <i class="el-icon-message"></i>{{ item.topic }}
          </div>
          <div class="message-item-content">
            {{ item.content | formatContent }}
          </div>
          <div class="message-item-time">{{ item.pubTime }}</div>
        </div>
      </div>
      <!-- 其他样式和交互逻辑... -->
    </div>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex'
import { getOpenUrl } from '@common/handleModules'
export default {
  data() {
    return {
      visible: false,
      currentMessage: '',
      minDialogFlag: false,
      lastSeenMessageId: null,
      openPageFlag: false, // 是否新打开窗口
      messageCount: 0
    }
  },
  computed: {
    /**
     * 菜单分组信息
     * @returns {*}
     */
    groups() {
      return this.$eventBus.getData(this.$eventBusDataKey.AUTH.GROUPS)
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (!val) {
          // 处理 $route 为空的情况
          return
        }
        if (
          val?.name &&
          oldVal?.name &&
          !['Login', 'Error'].includes(val?.name)
        ) {
          this.minDialogFlag = true
          let messageShowPopup = true
          if (window.localStorage.getItem('messageShowPopup') !== null) {
            messageShowPopup = JSON.parse(
              window.localStorage.getItem('messageShowPopup')
            )
          }
          if (!messageShowPopup) {
            this.visible = false
          }
        }
        if (['Login', 'Error'].includes(val?.name)) {
          this.visible = false
        }
        if (
          val?.path.includes('/open/') ||
          val?.path.includes('/noticeDetail')
        ) {
          this.openPageFlag = true
        }
      },
      immediate: true
    }
  },
  filters: {
    // 内容
    formatContent: function (content) {
      return content
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/gi, '')
        .replace(/\s+/g, ' ')
        .trim()
    }
  },
  created() {
    this.lastSeenMessageId = localStorage.getItem('lastSeenMessageId')
  },
  methods: {
    ...mapMutations('micro', ['SET_NAV_IDS']),
    show(message) {
      let route = this.$route
      if (['Login', 'Error'].includes(route?.name)) {
        this.visible = false
        return
      }
      if (message.length === 0 || message === '[]') {
        this.visible = false
      } else {
        const parsedMessages = JSON.parse(message)
        const firstMessageId = parsedMessages[0].id
        //  如果当前消息ID与最后看到的消息ID相同，则不显示消息
        if (this.lastSeenMessageId === firstMessageId || this.openPageFlag) {
          return
        }
        let loginInfo = localStorage.getItem('loginInfo')
        if (loginInfo) {
          this.visible = true
        }
        this.minDialogFlag = false
        this.messageCount =
          parsedMessages.length > 10 ? '10条+' : parsedMessages.length + '条'
        this.currentMessage = parsedMessages.slice(
          0,
          Math.min(parsedMessages.length, 10)
        )
        this.lastSeenMessageId = firstMessageId // 更新最后看到的消息ID
      }
    },
    closeMessage() {
      localStorage.setItem('lastSeenMessageId', this.lastSeenMessageId)
      this.visible = false
      this.currentMessage = ''
    },
    // 去公告消息
    goMyNotice(id, type) {
      let obj = this.groups._mods.find(
        (group) => '/mediacloud-article-my/myMessage' === group.route
      )
      if (obj) {
        this.SET_NAV_IDS({
          casId: obj.casId
        })
        this.visible = false
        const typeMap = {
          0: 'notice',
          1: 'todo',
          2: 'plan',
          4: 'layout'
        }
        const messageType = typeMap[+type] || ''
        let openUrl = getOpenUrl({
          url: `/service/mediacloud-article-my/myNotice`,
          params: { type: messageType, id: id }
        })
        this.$router.push(openUrl)
      } else {
        this.$message.error('暂无权限，联系管理员授权')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.global-message {
  width: 360px;
  height: 280px;
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 10px;
  z-index: 990; /* 确保弹框在子应用之上 */
  transition: bottom 1s;
  -o-transition: bottom 1s;
  -ms-transition: bottom 1s;
  -moz-transition: bottom 1s;
  -webkit-transition: bottom 1s;
  .message-head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    .message-title {
      font-size: 16px;
      color: #333333;
      span {
        color: #006bff;
      }
    }
    i {
      float: right;
      width: 20px;
      height: 20px;
      margin: 10px 0 0 14px;
      cursor: pointer;
    }
    .close_message_icon {
      background: url(../assets/img/message_close.png) no-repeat center center;
    }
    .min_message_icon {
      background: url(../assets/img/min_message.png) no-repeat center center;
    }
    .max_message_icon {
      background: url(../assets/img/max_message.png) no-repeat center center;
    }
  }
  .message-content {
    overflow: auto;
    height: 220px;
  }
  .message-item {
    width: 100%;
    padding: 10px 0;
    &:hover {
      background: #f0f3fa;
    }
    cursor: pointer;
    .message-item-title {
      font-weight: bolder;
      font-size: 14px;
      color: #454647;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      i {
        font-size: 14px;
        color: #006bff;
        margin: 0 4px 0 10px;
      }
    }
    .message-item-content {
      font-size: 14px;
      color: #333;
      padding-left: 28px;
      margin: 8px 0;
      cursor: pointer;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -moz-box;
      -moz-line-clamp: 2;
      -moz-box-orient: vertical;
      overflow-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      overflow: hidden;
    }
    .message-item-time {
      font-size: 13px;
      padding-left: 28px;
      color: #959697;
    }
  }
}
/* 进入动画 */
.slide-up-fade-enter-active,
.slide-up-fade-leave-active {
  transition: bottom 1s, opacity 0.3s;
}
.slide-up-fade-enter,
.slide-up-fade-leave-to {
  bottom: -300px;
  opacity: 0;
}
.max {
  bottom: -230px;
  transition: bottom 1s;
  -o-transition: bottom 1s;
  -ms-transition: bottom 1s;
  -moz-transition: bottom 1s;
  -webkit-transition: bottom 1s;
  &.global-message {
    background: #f0f8ff;
  }
}
</style>
